import {AccessorsMutatorsDecorator, Model} from "../../helpers";


export class CurrencyCode extends Model {}

AccessorsMutatorsDecorator(
    'id',
    'code',
    'name'
)(CurrencyCode);


// WEBPACK FOOTER //
// ./src/pms-api/models/currency-code.model.js